const _import = (name) => {
  return (resolve) => require([`../../views/${name}`], resolve);
};
const FundsChild = {
  path: "/funds",
  meta: {
    navShow: false,
    titleHide: true,
    title: "充提",
    requireAuth: true,
  },
  component: _import("funds"),
  redirect: "/funds/deposite",
  children: [
    {
      path: "deposite",
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: "充值",
      },
      name: "deposite",
      component: _import("funds/deposite"),
    },
    {
      path: "withdraw",
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: "提现",
      },
      name: "withdraw",
      component: _import("funds/withdraw"),
    },
    {
      path: "BankTransfer",
      meta: {
        navShow: false,
        titleHide: false,
        title: "银行汇款",
      },
      name: "BankTransfer",
      component: _import("SaveMonery/BankTransfer"),
    },
    {
      path: "BankTransfer2",
      meta: {
        navShow: false,
        titleHide: false,
        title: "半自动银行汇款",
      },
      name: "BankTransfer2",
      component: _import("SaveMonery/BankTransfer/index2.vue"),
    },
    {
      path: "BankTransfer3",
      meta: {
        navShow: false,
        titleHide: false,
        title: "全自动银行汇款",
      },
      name: "BankTransfer3",
      component: _import("SaveMonery/BankTransfer/index3.vue"),
    },
    {
      path: "otherTransfer",
      meta: {
        navShow: false,
        titleHide: false,
        title: "otherTransfer",
      },
      name: "otherTransfer",
      component: _import("SaveMonery/otherTransfer"),
    },
    {
      path: "otherTransfer2",
      meta: {
        navShow: false,
        titleHide: false,
        title: "otherTransfer2",
      },
      name: "otherTransfer2",
      component: _import("SaveMonery/otherTransfer/index2.vue"),
    },
    {
      path: "otherTransfer3",
      meta: {
        navShow: false,
        titleHide: false,
        title: "otherTransfer3",
      },
      name: "otherTransfer3",
      component: _import("SaveMonery/otherTransfer/index3.vue"),
    },
    {
      path: "recharge",
      meta: {
        navShow: false,
        titleHide: false,
        title: "Recharge",
      },
      name: "Recharge",
      component: _import("SaveMonery/Recharge"),
    },
  ],
};

export default FundsChild;



// WEBPACK FOOTER //
// ./src/pages/build800/router/module/funds.js